import { render } from "./ViewProfilePublic.vue?vue&type=template&id=08922bd6&scoped=true"
import script from "./ViewProfilePublic.vue?vue&type=script&lang=js"
export * from "./ViewProfilePublic.vue?vue&type=script&lang=js"

import "./ViewProfilePublic.vue?vue&type=style&index=0&id=08922bd6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08922bd6"]])

export default __exports__